<template>
  <div class="d-inline">
    <v-btn icon title="Visualizar Histórico" v-on:click="showTimeline()">
      <v-icon>mdi-timeline-text</v-icon>
    </v-btn>
    <v-dialog v-model="dialog" width="600">
      <v-card>
        <v-card-title class="headline teal white--text darken-4">
          Andamento do Processo
        </v-card-title>

          <v-card-text class="card-text">
            <v-timeline dense clipped v-if="transactions.length > 0">
              <v-timeline-item
                v-for="transaction in transactions"
                :key="transaction.id"
                class="mb-3"
                color="green darken-2"
                icon-color="green darken-2"
                small>
                <v-layout justify-space-between>
                  <v-layout column>
                    <v-flex xs7>
                      {{ transaction.destination.name }}
                    </v-flex>
                    <v-flex v-if="transaction.to_user" xs7>
                      {{ transaction.to_user.name }}
                    </v-flex>
                    <v-flex v-else xs7>
                      Responsável não encontrado
                    </v-flex>
                    <v-flex xs3 text-xs-right>{{ transaction.created_at | formatDate }}</v-flex>
                  </v-layout>
                </v-layout>
              </v-timeline-item>
              <v-timeline-item
                class="mb-3"
                color="grey"
                small>
                <v-layout align-center justify-space-between>
                  <v-layout column>
                    <v-flex xs7>
                      {{ transactions[transactions.length-1].origin.name }}
                    </v-flex>
                    <v-flex v-if="transactions[transactions.length-1].from_user" xs7>
                      {{ transactions[transactions.length-1].from_user.name }}
                    </v-flex>
                    <v-flex v-else xs7>
                      Aguardando Recebimento
                    </v-flex>
                  </v-layout>
                  <v-flex xs5 text-xs-right>
                    {{ transactions[transactions.length-1].created_at | formatDate }}
                  </v-flex>
                </v-layout>
              </v-timeline-item>
            </v-timeline>
            <div v-else class="text-xs-center">
              Processo ainda não foi tramitado
            </div>
          </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="red" flat @click="dialog = false">
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ApplicationService from '@/services/applications/ApplicationService';

export default {
  name: 'ApplicationHistoricComponent',
  props: ['application'],
  data() {
    return {
      dialog: false,
      transactions: [],
    };
  },
  methods: {
    showTimeline() {
      this.$store.dispatch('setLoadingDialog', true);
      const vm = this;
      ApplicationService
        .showHistoric(this.application.folder_number, this.application.person.cpf_cnpj)
        .then((response) => {
          vm.transactions = response.data.transactions;
          vm.dialog = true;
        })
        .catch(() => {
          this.$swal({
            type: 'error',
            titleText: 'Não foi possível obter as tramitações. Tente novamente em alguns instantes',
          });
        })
        .finally(() => {
          this.$store.dispatch('setLoadingDialog', false);
        });
    },
    showApplication(application) {
      this.$store.dispatch('setLoadingDialog', true);
      this.$router.push(`${application.id}/visualizar`);
    },
  },
};
</script>
<style scoped>
  .item:hover{
    background: #dbdbdb;
  }
  .card-text {
    max-height: 500px;
    overflow-y: auto
  }
</style>
